export default __webpack_public_path__ + "bc65e65eb1f85664b9cfb5f8dc6db1c0.png";